export default __webpack_public_path__ + "static/media/cucsci.f6f4c0ac.png";